<template>
    <div class="form-label-group mt-5">
        <input type="text" class="form-control" id="floatingInput" placeholder=" " v-model="searchTerm" @input="search" @click="searchOpen = true">
        <label for="floatingInput"><i class="fas fa-search"></i> Waar ben je naar op
            zoek?</label>
    </div>
    <Transition
        @before-enter="onBeforeEnter"
        @enter="onEnter"
        @leave="onLeave"
        :css="false"
    >
        <div class="search-results" v-if="searchResults.length > 0 && searchOpen">
            <div class="tab-content" id="pills-tabContent">
                <div v-for="(searchIndex, i) in searchResults">
                    <template v-for="(groupedHits, u) in searchIndex.hits">
                        <ul v-if="selectedPage === u">
                            <li v-for="(result, k) in groupedHits" :class="(selectedIndex.selectedHit !== null && selectedIndex.selectedHit === result ? ' active' : '')" @click.prevent="gotoItem(result)"
                                @mouseover="selectedIndex.selectedHit = result">
                                <div class="d-flex">
                                    <div :class="'search-result-image ' + searchIndex.title" :style="'background-image: url(' + (result.image ?? '/img/dots.svg') + ');' + (result.image === null ? ' background-color: #fff;' : '')"></div>
                                    <div class="search-result-body align-self-center">
                                        <a class="color-primary" :href="result.url" v-html="result.title"></a>
                                        <span class="color-darkgreen d-block">{{ result.formattedOnlineDate }}</span>
                                        <p v-html="result.body || result.summary"></p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </template>
                    <div class="d-flex justify-content-between">
                        <button class="btn btn-primary" @click="previousPage(searchIndex)" :disabled="selectedPage - 1 < 0">&laquo; Vorige pagina</button>
                        <button class="btn btn-primary" @click="nextPage(searchIndex);" :disabled="selectedPage + 1 >= searchIndex.hits.length">Volgende pagina &raquo;</button>
                    </div>
                    <ul>
                        <li class="search-result-footer">
                            <div class="d-flex">
                                <div class="flex-fill"><span>{{ searchIndex.estimatedTotalHits }}</span> zoekresultaten voor "{{ searchTerm }}".</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import {ref, onMounted, watch} from 'vue';
import {Modal} from 'bootstrap';
import {debounce} from '@/js/helpers.js';
import axios from 'axios';
import {onBeforeEnter, onEnter, onLeave} from '@/js/transitions.js';

const searchResults = ref([]);
const searchTerm    = ref('');
const selectedIndex = ref({
    index:       null,
    indexSlug:   null,
    selectedHit: null
})
let searchIcon      = null;
const selectedPage  = ref(0);
const searchOpen    = ref(false);

watch(searchResults, (newValue, oldValue) => {
    if(newValue.length > 0) {
        selectedIndex.value.index       = 0;
        selectedIndex.value.selectedHit = newValue[0].hits[0];
    }
});

const search = debounce((e) => {
    history.replaceState({}, '', window.location.pathname + '?q=' + searchTerm.value);

    if(searchTerm.value.length > 2) {
        searchIcon.classList.replace('fa-search', 'fa-circle-notch');
        searchIcon.classList.add('fa-spin');
        axios.post('/api/zoeken', {
            params: {
                q: searchTerm.value,
            }
        }).then((response) => {
            searchResults.value = response.data;
            selectedPage.value  = 0;
            searchOpen.value    = true;
        }).catch((error) => {
            searchResults.value = [];
            selectedPage.value  = 0;
            searchOpen.value    = true;
        }).finally(() => {
            searchIcon.classList.replace('fa-circle-notch', 'fa-search');
            searchIcon.classList.remove('fa-spin');
        });
    } else {
        searchResults.value = [];
        selectedPage.value  = 0;
        searchOpen.value    = false;
    }
}, 500);

const previousPage = (searchIndex) => {
    if(selectedPage.value - 1 >= 0) {
        selectedPage.value--;
    }
}

const nextPage = (searchIndex) => {
    if(selectedPage.value + 1 < searchIndex.hits.length) {
        selectedPage.value++;
    }
}

const gotoItem = (item) => {
    window.location.assign(item.url);
}

onMounted(() => {
    document.addEventListener('click', (event) => {
        if(searchOpen.value === true) {
            if(!document.querySelector('#search-form-app').contains(event.target)) {
                searchOpen.value = false;
            }
        }
    })

    document.addEventListener('keydown', (e) => {
        if(['ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) {
            e.preventDefault();
            switch(e.key) {
                case 'ArrowDown':
                    if(selectedIndex.value.selectedHit === null) {
                        selectedIndex.value.selectedHit = searchResults.value[0].hits[0];
                    } else {
                        let index = searchResults.value[selectedIndex.value.index].hits.indexOf(selectedIndex.value.selectedHit);
                        if(index < searchResults.value[selectedIndex.value.index].hits.length - 1) {
                            selectedIndex.value.selectedHit = searchResults.value[selectedIndex.value.index].hits[index + 1];
                        }
                    }
                    break;
                case 'ArrowUp':
                    if(selectedIndex.value.selectedHit === null) {
                        selectedIndex.value.selectedHit = searchResults.value[0].hits[0];
                    } else {
                        let index = searchResults.value[selectedIndex.value.index].hits.indexOf(selectedIndex.value.selectedHit);
                        if(index > 0) {
                            selectedIndex.value.selectedHit = searchResults.value[selectedIndex.value.index].hits[index - 1];
                        }
                    }
                    break;

                case 'ArrowLeft':
                    if(selectedIndex.value.index > 0) {
                        selectedIndex.value.index--;
                        selectedIndex.value.selectedHit = searchResults.value[selectedIndex.value.index].hits[0];

                        setTimeout(() => {
                            document.querySelector('[data-bs-target="#pills-' + searchResults.value[selectedIndex.value.index].slug + '"]').click();
                        }, 1);
                    }
                    break;
                case 'ArrowRight':
                    if(selectedIndex.value.index < searchResults.value.length - 1) {
                        selectedIndex.value.index++;
                        selectedIndex.value.selectedHit = searchResults.value[selectedIndex.value.index].hits[0];

                        setTimeout(() => {
                            document.querySelector('[data-bs-target="#pills-' + searchResults.value[selectedIndex.value.index].slug + '"]').click();
                        }, 1);
                    }
                    break;
                case 'Enter':
                    if(selectedIndex.value.selectedHit !== null) {
                        gotoItem(selectedIndex.value.selectedHit);
                    }
                    break;
            }
        }
    });
    searchIcon      = document.querySelector('.fa-search');
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('q')) {
        searchTerm.value = urlParams.get('q');
        search();
    }
});
</script>